import React from "react";
import StudentAvatar from "./StudentAvatar";

interface ChatAvatarProps {
  name?: string;
  imageUrl?: string | null;
  size?: "sm" | "md";
  /** Presence dot: true = online (green), false = offline (grey), null/undefined = no dot. */
  isOnline?: boolean | null;
}

/**
 * Chat avatar — the shared `StudentAvatar` (participant image, falling back to
 * an initial circle) with an optional presence dot, mirroring the RN
 * `ChatAvatar` used by the chat list and the message thread header.
 */
const ChatAvatar: React.FC<ChatAvatarProps> = ({
  name = "",
  imageUrl,
  size = "md",
  isOnline,
}) => {
  const showDot = isOnline !== null && isOnline !== undefined;

  return (
    <span className="relative inline-flex shrink-0">
      <StudentAvatar src={imageUrl} name={name} size={size} />
      {showDot && (
        <span
          className={`absolute bottom-0 right-0 block rounded-full border-2 border-white ${
            size === "sm" ? "h-2.5 w-2.5" : "h-3 w-3"
          } ${isOnline ? "bg-[#25D366]" : "bg-[#b0b3b8]"}`}
        />
      )}
    </span>
  );
};

export default ChatAvatar;
